import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const noticeAPI = {
  // 공지사항 전체 조회 (페이지)
  async getNoticesAPI(params?: { page: number }): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(`${END_POINT.noticesController.getNotices()}`, {
        params, // 페이지 정보 전달
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // 공지사항 단일 조회
  getNoticesIdAPI: async (id: number) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.get<any>(END_POINT.noticesController.getNoticesId(id), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // 공지사항 추가
  postNoticesCreateAPI: async (data: any) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.post<any>(END_POINT.noticesController.postNoticesCreate(), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // 공지사항 삭제
  deleteNoticesIdAPI: async (id: number) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.delete<any>(END_POINT.noticesController.deleteNoticesId(id), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // 팝업 공지사항 전체 조회
  getNoticesPopupAPI: async () => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.get<any>(END_POINT.noticesController.getNoticesPopup(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // 공지사항 변경
  putNoticesUpdateIdAPI: async (id: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.put<any>(END_POINT.noticesController.putNoticesUpdateId(id), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export const { getNoticesAPI, getNoticesIdAPI, postNoticesCreateAPI, deleteNoticesIdAPI, getNoticesPopupAPI, putNoticesUpdateIdAPI } = noticeAPI;
